import type { RegisterError, RegisterErrorCode } from './result';

// Codes thrown by lib/auth.ts hooks.before for /sign-up/email — server message is user-facing as-is.
const KNOWN_ERROR_CODES: Record<string, RegisterErrorCode> = {
  MISSING_WELCOME_BONUS: 'missing_welcome_bonus',
  DEVICE_BLOCKED: 'device_blocked',
  INVALID_AFFILIATE: 'invalid_affiliate',
};

export const mapAuthError = (error: string, code?: string): RegisterError => {
  const knownCode = code ? KNOWN_ERROR_CODES[code] : undefined;
  if (knownCode) {
    return { code: knownCode, message: error };
  }

  const errorMessage = error.toLowerCase();

  if (errorMessage.includes('email') && errorMessage.includes('exists')) {
    return {
      code: 'email_exists',
      message: 'Este email ya está registrado',
    };
  }

  return {
    code: 'general',
    message: `Error en el registro: ${error}`,
  };
};
